import { render } from "./Inventarization.vue?vue&type=template&id=28d08baa&scoped=true"
import script from "./Inventarization.vue?vue&type=script&lang=js"
export * from "./Inventarization.vue?vue&type=script&lang=js"

import "./Inventarization.vue?vue&type=style&index=0&id=28d08baa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d08baa"]])

export default __exports__